{
  "username": "ユーザー名",
  "password": "パスワード",
  "login": "ログイン",
  "confirm": "確認",
  "cancel": "キャンセル",
  "close": "閉じる",
  "save": "保存",
  "logout": "ログアウト",
  "create": "作成",
  "add": "追加",
  "remove": "削除",
  "update": "更新",
  "copy": "コピー",
  "copied": "コピー済み",
  "more": "もっと",
  "download": "ダウンロード",
  "remark": "備考",
  "enable": "有効化",
  "protocol": "プロトコル",
  "search": "検索",
  "filter": "フィルタ",
  "all": "すべて",
  "from": "から",
  "to": "まで",
  "done": "完了",
  "loading": "読み込み中...",
  "refresh": "更新",
  "clear": "クリア",
  "second": "秒",
  "minute": "分",
  "hour": "時間",
  "day": "日",
  "check": "確認",
  "indefinite": "無期限",
  "unlimited": "無制限",
  "none": "なし",
  "qrCode": "QRコード",
  "info": "詳細情報",
  "edit": "編集",
  "delete": "削除",
  "reset": "リセット",
  "noData": "データなし。",
  "copySuccess": "コピー成功",
  "sure": "確定",
  "encryption": "暗号化",
  "useIPv4ForHost": "ホストにIPv4を使用",
  "transmission": "伝送",
  "host": "ホスト",
  "path": "パス",
  "camouflage": "難読化",
  "status": "ステータス",
  "enabled": "有効",
  "disabled": "無効",
  "depleted": "消耗済み",
  "depletingSoon": "間もなく消耗",
  "offline": "オフライン",
  "online": "オンライン",
  "domainName": "ドメイン名",
  "monitor": "監視",
  "certificate": "証明書",
  "fail": "失敗",
  "comment": "コメント",
  "success": "成功",
  "lastOnline": "最終オンライン",
  "getVersion": "バージョン取得",
  "install": "インストール",
  "clients": "クライアント",
  "usage": "利用状況",
  "twoFactorCode": "コード",
  "remained": "残り",
  "security": "セキュリティ",
  "secAlertTitle": "セキュリティアラート",
  "secAlertSsl": "この接続は安全ではありません。TLSを有効にしてデータ保護を行うまで、機密情報を入力しないでください。",
  "secAlertConf": "一部の設定は脆弱です。潜在的な脆弱性を防ぐために、セキュリティプロトコルを強化することをお勧めします。",
  "secAlertSSL": "セキュアな接続がありません。データ保護のためにTLS証明書をインストールしてください。",
  "secAlertPanelPort": "デフォルトのポートにはセキュリティリスクがあります。ランダムなポートまたは特定のポートを設定してください。",
  "secAlertPanelURI": "デフォルトのURIパスは安全ではありません。複雑なURIパスを設定してください。",
  "secAlertSubURI": "サブスクリプションのデフォルトURIパスは安全ではありません。複雑なURIパスを設定してください。",
  "secAlertSubJsonURI": "JSONサブスクリプションのデフォルトURIパスは安全ではありません。複雑なURIパスを設定してください。",
  "emptyDnsDesc": "追加されたDNSサーバーはありません。",
  "emptyFakeDnsDesc": "追加されたFake DNSサーバーはありません。",
  "emptyBalancersDesc": "追加されたバランサーはありません。",
  "emptyReverseDesc": "追加されたリバースプロキシはありません。",
  "somethingWentWrong": "エラーが発生しました",
  "subscription": {
    "title": "サブスクリプション情報",
    "subId": "サブスクリプションID",
    "status": "ステータス",
    "downloaded": "ダウンロード",
    "uploaded": "アップロード",
    "expiry": "有効期限",
    "totalQuota": "合計クォータ",
    "individualLinks": "個別リンク",
    "active": "有効",
    "inactive": "無効",
    "unlimited": "無制限",
    "noExpiry": "期限なし"
  },
  "menu": {
    "theme": "テーマ",
    "dark": "ダーク",
    "ultraDark": "ウルトラダーク",
    "dashboard": "ダッシュボード",
    "inbounds": "インバウンド",
    "clients": "クライアント",
    "groups": "グループ",
    "nodes": "ノード",
    "settings": "パネル設定",
    "xray": "Xray 設定",
    "apiDocs": "API ドキュメント",
    "logout": "ログアウト",
    "link": "リンク管理",
    "donate": "寄付"
  },
  "pages": {
    "login": {
      "hello": "こんにちは",
      "title": "ようこそ",
      "loginAgain": "ログインセッションが切れました。再度ログインしてください。",
      "toasts": {
        "invalidFormData": "データ形式エラー",
        "emptyUsername": "ユーザー名を入力してください",
        "emptyPassword": "パスワードを入力してください",
        "wrongUsernameOrPassword": "ユーザー名、パスワード、または二段階認証コードが無効です。",
        "successLogin": "アカウントに正常にログインしました。"
      }
    },
    "index": {
      "title": "システムステータス",
      "cpu": "CPU",
      "logicalProcessors": "論理プロセッサ",
      "frequency": "周波数",
      "swap": "Swap",
      "storage": "ストレージ",
      "memory": "RAM",
      "threads": "スレッド",
      "xrayStatus": "Xray",
      "stopXray": "停止",
      "restartXray": "再起動",
      "xraySwitch": "バージョン",
      "xrayUpdates": "Xrayの更新",
      "xraySwitchClick": "切り替えるバージョンを選択してください",
      "xraySwitchClickDesk": "慎重に選択してください。古いバージョンは現在の設定と互換性がない可能性があります。",
      "updatePanel": "パネルを更新",
      "panelUpdateDesc": "これにより3X-UIが最新リリースに更新され、パネルサービスが再起動されます。",
      "currentPanelVersion": "現在のパネルバージョン",
      "latestPanelVersion": "最新のパネルバージョン",
      "panelUpToDate": "パネルは最新です",
      "upToDate": "最新",
      "xrayStatusUnknown": "不明",
      "xrayStatusRunning": "実行中",
      "xrayStatusStop": "停止",
      "xrayStatusError": "エラー",
      "xrayErrorPopoverTitle": "Xrayの実行中にエラーが発生しました",
      "operationHours": "システム稼働時間",
      "systemHistoryTitle": "システム履歴",
      "charts": "チャート",
      "xrayMetricsTitle": "Xray メトリクス",
      "xrayMetricsDisabled": "Xray メトリクスエンドポイントが設定されていません",
      "xrayMetricsHint": "xray 設定にトップレベルの metrics ブロック(tag: metrics_out、listen: 127.0.0.1:11111)を追加し、xray を再起動してください。",
      "xrayObservatoryEmpty": "Observatory データはまだありません",
      "xrayObservatoryHint": "xray 設定に observatory ブロックを追加し、プローブする outbound タグを列挙してから xray を再起動してください。",
      "xrayObservatoryTagPlaceholder": "Outbound を選択",
      "xrayObservatoryAlive": "稼働中",
      "xrayObservatoryDead": "停止",
      "xrayObservatoryLastSeen": "最終確認",
      "xrayObservatoryLastTry": "最終試行",
      "trendLast2Min": "直近2分",
      "systemLoad": "システム負荷",
      "systemLoadDesc": "過去1、5、15分間のシステム平均負荷",
      "connectionCount": "接続数",
      "ipAddresses": "IPアドレス",
      "toggleIpVisibility": "IPの表示を切り替える",
      "overallSpeed": "全体の速度",
      "upload": "アップロード",
      "download": "ダウンロード",
      "totalData": "総データ量",
      "sent": "送信",
      "received": "受信",
      "documentation": "ドキュメント",
      "xraySwitchVersionDialog": "Xrayのバージョンを本当に変更しますか？",
      "xraySwitchVersionDialogDesc": "Xrayのバージョンが#version#に変更されます。",
      "xraySwitchVersionPopover": "Xrayの更新が成功しました",
      "panelUpdateDialog": "本当にパネルを更新しますか？",
      "panelUpdateDialogDesc": "これにより3X-UIが#version#に更新され、パネルサービスが再起動されます。",
      "panelUpdateCheckPopover": "パネルの更新確認に失敗しました",
      "panelUpdateStartedPopover": "パネルの更新を開始しました",
      "geofileUpdateDialog": "ジオファイルを本当に更新しますか？",
      "geofileUpdateDialogDesc": "これにより#filename#ファイルが更新されます。",
      "geofilesUpdateDialogDesc": "これにより、すべてのファイルが更新されます。",
      "geofilesUpdateAll": "すべて更新",
      "geofileUpdatePopover": "ジオファイルの更新が成功しました",
      "customGeoTitle": "カスタム GeoSite / GeoIP",
      "customGeoAdd": "追加",
      "customGeoType": "種類",
      "customGeoAlias": "エイリアス",
      "customGeoUrl": "URL",
      "customGeoEnabled": "有効",
      "customGeoLastUpdated": "最終更新",
      "customGeoExtColumn": "ルーティング (ext:…)",
      "customGeoToastUpdateAll": "すべてのカスタムソースを更新しました",
      "customGeoActions": "操作",
      "customGeoEdit": "編集",
      "customGeoDelete": "削除",
      "customGeoDownload": "今すぐ更新",
      "customGeoModalAdd": "カスタム geo を追加",
      "customGeoModalEdit": "カスタム geo を編集",
      "customGeoModalSave": "保存",
      "customGeoDeleteConfirm": "このカスタム geo ソースを削除しますか？",
      "customGeoRoutingHint": "ルーティングでは値を ext:ファイル.dat:タグ（タグを置換）として使います。",
      "customGeoInvalidId": "無効なリソース ID",
      "customGeoAliasesError": "カスタム geo エイリアスの読み込みに失敗しました",
      "customGeoValidationAlias": "エイリアスは小文字・数字・- と _ のみ使用できます",
      "customGeoValidationUrl": "URL は http:// または https:// で始めてください",
      "customGeoAliasPlaceholder": "a-z 0-9 _ -",
      "customGeoAliasLabelSuffix": "（カスタム）",
      "customGeoToastList": "カスタム geo 一覧",
      "customGeoToastAdd": "カスタム geo を追加",
      "customGeoToastUpdate": "カスタム geo を更新",
      "customGeoToastDelete": "カスタム geofile「{{ .fileName }}」を削除しました",
      "customGeoToastDownload": "geofile「{{ .fileName }}」を更新しました",
      "customGeoErrInvalidType": "種類は geosite または geoip である必要があります",
      "customGeoErrAliasRequired": "エイリアスが必要です",
      "customGeoErrAliasPattern": "エイリアスに使用できない文字が含まれています",
      "customGeoErrAliasReserved": "このエイリアスは予約されています",
      "customGeoErrUrlRequired": "URL が必要です",
      "customGeoErrInvalidUrl": "URL が無効です",
      "customGeoErrUrlScheme": "URL は http または https を使用してください",
      "customGeoErrUrlHost": "URL のホストが無効です",
      "customGeoErrDuplicateAlias": "この種類ですでにこのエイリアスが使われています",
      "customGeoErrNotFound": "カスタム geo ソースが見つかりません",
      "customGeoErrDownload": "ダウンロードに失敗しました",
      "customGeoErrUpdateAllIncomplete": "カスタム geo ソースの 1 件以上を更新できませんでした",
      "customGeoEmpty": "カスタム geo ソースはまだありません — 「追加」をクリックして作成してください",
      "dontRefresh": "インストール中、このページをリロードしないでください",
      "logs": "ログ",
      "config": "設定",
      "backup": "バックアップ",
      "backupTitle": "バックアップと復元",
      "exportDatabase": "バックアップ",
      "exportDatabaseDesc": "クリックして、現在のデータベースのバックアップを含む .db ファイルをデバイスにダウンロードします。",
      "importDatabase": "復元",
      "importDatabaseDesc": "クリックして、デバイスから .db ファイルを選択し、アップロードしてバックアップからデータベースを復元します。",
      "importDatabaseSuccess": "データベースのインポートに成功しました",
      "importDatabaseError": "データベースのインポート中にエラーが発生しました",
      "readDatabaseError": "データベースの読み取り中にエラーが発生しました",
      "getDatabaseError": "データベースの取得中にエラーが発生しました",
      "getConfigError": "設定ファイルの取得中にエラーが発生しました"
    },
    "inbounds": {
      "title": "インバウンド",
      "totalDownUp": "総アップロード / ダウンロード",
      "totalUsage": "総使用量",
      "inboundCount": "インバウンド数",
      "operate": "メニュー",
      "enable": "有効化",
      "remark": "備考",
      "node": "ノード",
      "deployTo": "デプロイ先",
      "localPanel": "ローカルパネル",
      "fallbacks": {
        "title": "Fallbacks",
        "help": "このインバウンドへの接続がどのクライアントにも一致しない場合、別のインバウンドへルーティングします。下から子インバウンドを選ぶと、ルーティング項目（SNI / ALPN / Path / xver）はその子のトランスポートから自動的に埋められます — ほとんどの構成で追加の調整は不要です。各子インバウンドは 127.0.0.1 で security=none をリッスンする必要があります。",
        "empty": "フォールバックはまだありません",
        "add": "フォールバックを追加",
        "pickInbound": "インバウンドを選択",
        "matchAny": "任意",
        "destPlaceholder": "自動（子の listen:port）",
        "rederive": "子から再取得",
        "rederived": "子から再取得しました",
        "editAdvanced": "ルーティング項目を編集",
        "hideAdvanced": "詳細を隠す",
        "quickAddAll": "対象のインバウンドをすべて一括追加",
        "quickAdded": "{n} 件のフォールバックを追加しました",
        "quickAddedNone": "追加可能な新規インバウンドはありません",
        "routesWhen": "次の条件でルーティング",
        "defaultCatchAll": "デフォルト — その他すべてを捕捉"
      },
      "protocol": "プロトコル",
      "port": "ポート",
      "portMap": "ポートマッピング",
      "traffic": "トラフィック",
      "details": "詳細情報",
      "transportConfig": "トランスポート",
      "expireDate": "有効期限",
      "createdAt": "作成",
      "updatedAt": "更新",
      "resetTraffic": "トラフィックをリセット",
      "addInbound": "インバウンド追加",
      "generalActions": "一般操作",
      "modifyInbound": "インバウンド修正",
      "deleteInbound": "インバウンド削除",
      "deleteInboundContent": "インバウンドを削除してもよろしいですか？",
      "deleteConfirmTitle": "インバウンド「{remark}」を削除しますか？",
      "deleteConfirmContent": "インバウンドと関連付けされたすべてのクライアントを削除します。元に戻せません。",
      "resetConfirmTitle": "「{remark}」のトラフィックをリセットしますか？",
      "resetConfirmContent": "このインバウンドの送受信カウンタを 0 にリセットします。",
      "cloneConfirmTitle": "インバウンド「{remark}」を複製しますか？",
      "cloneConfirmContent": "新しいポートと空のクライアント一覧でコピーを作成します。",
      "delAllClients": "すべてのクライアントを削除",
      "delAllClientsConfirmTitle": "「{remark}」から {count} 件のクライアントをすべて削除しますか？",
      "delAllClientsConfirmContent": "このインバウンドからすべてのクライアントを削除し、トラフィックレコードも破棄します。インバウンド自体は保持されます。この操作は取り消せません。",
      "attachClients": "クライアントをアタッチ…",
      "addClientsToGroup": "クライアントをグループに追加…",
      "attachClientsTitle": "「{remark}」のクライアントをアタッチ",
      "attachClientsDesc": "同じ {count} クライアント(同じ UUID/パスワードと共有トラフィック)を選択したインバウンドにアタッチします。このインバウンドにも残ります。",
      "attachClientsTargets": "ターゲットインバウンド",
      "attachClientsNoTargets": "アタッチ可能な互換インバウンドがありません。",
      "attachClientsResult": "アタッチ {attached}、スキップ {skipped}。",
      "attachClientsResultMixed": "アタッチ {attached}、スキップ {skipped}、エラー {errors}。",
      "attachClientsSelectLabel": "アタッチするクライアント",
      "attachClientsSearchPlaceholder": "メールまたはコメントを検索",
      "attachClientsStatusDisabled": "無効",
      "attachClientsSelectedCount": "{total} 中 {selected} 選択中",
      "detachClients": "クライアントをデタッチ",
      "detachClientsTitle": "「{remark}」のクライアントをデタッチ",
      "detachClientsDesc": "選択したクライアントをこのインバウンドのみから外します。クライアントレコードは保持されます (完全に削除するには Delete を使用)。ソースには合計 {count} クライアントがあります。",
      "detachClientsResult": "デタッチ {detached}、スキップ {skipped}。",
      "detachClientsResultMixed": "デタッチ {detached}、スキップ {skipped}、エラー {errors}。",
      "detachClientsSelectLabel": "デタッチするクライアント",
      "exportLinksTitle": "インバウンドリンクのエクスポート",
      "exportSubsTitle": "サブスクリプションリンクのエクスポート",
      "exportAllLinksTitle": "全インバウンドリンクのエクスポート",
      "exportAllSubsTitle": "全サブスクリプションリンクのエクスポート",
      "exportAllLinksFileName": "全インバウンド",
      "exportAllSubsFileName": "全インバウンド-Subs",
      "inboundJsonTitle": "インバウンド JSON",
      "deleteClient": "クライアント削除",
      "deleteClientContent": "クライアントを削除してもよろしいですか？",
      "resetTrafficContent": "トラフィックをリセットしてもよろしいですか？",
      "copyLink": "リンクをコピー",
      "address": "アドレス",
      "network": "ネットワーク",
      "destinationPort": "宛先ポート",
      "targetAddress": "宛先アドレス",
      "monitorDesc": "空白にするとすべてのIPを監視",
      "meansNoLimit": "= 無制限。(単位: GB)",
      "totalFlow": "総トラフィック",
      "leaveBlankToNeverExpire": "空白にすると期限なし",
      "noRecommendKeepDefault": "デフォルト値を保持することをお勧めします",
      "certificatePath": "ファイルパス",
      "certificateContent": "ファイル内容",
      "publicKey": "公開鍵",
      "privatekey": "秘密鍵",
      "clickOnQRcode": "QRコードをクリックしてコピー",
      "client": "クライアント",
      "export": "リンクエクスポート",
      "clone": "複製",
      "cloneInbound": "複製",
      "cloneInboundContent": "このインバウンドルールは、ポート（Port）、リスニングIP（Listening IP）、クライアント（Clients）を除くすべての設定がクローンされます",
      "cloneInboundOk": "クローン作成",
      "resetAllTraffic": "すべてのインバウンドトラフィックをリセット",
      "resetAllTrafficTitle": "すべてのインバウンドトラフィックをリセット",
      "resetAllTrafficContent": "すべてのインバウンドトラフィックをリセットしてもよろしいですか？",
      "resetInboundClientTraffics": "クライアントトラフィックをリセット",
      "resetInboundClientTrafficTitle": "すべてのクライアントトラフィックをリセット",
      "resetInboundClientTrafficContent": "このインバウンドクライアントのすべてのトラフィックをリセットしてもよろしいですか？",
      "resetAllClientTraffics": "すべてのクライアントトラフィックをリセット",
      "resetAllClientTrafficTitle": "すべてのクライアントトラフィックをリセット",
      "resetAllClientTrafficContent": "すべてのクライアントのトラフィックをリセットしてもよろしいですか？",
      "delDepletedClients": "トラフィックが尽きたクライアントを削除",
      "delDepletedClientsTitle": "トラフィックが尽きたクライアントを削除",
      "delDepletedClientsContent": "トラフィックが尽きたすべてのクライアントを削除してもよろしいですか？",
      "email": "メール",
      "emailDesc": "メールアドレスは一意でなければなりません",
      "IPLimit": "IP制限",
      "IPLimitDesc": "設定値を超えるとインバウンドトラフィックが無効になります。（0 = 無効）",
      "IPLimitlog": "IPログ",
      "IPLimitlogDesc": "IP履歴ログ（無効なインバウンドトラフィックを有効にするには、ログをクリアしてください）",
      "IPLimitlogclear": "ログをクリア",
      "setDefaultCert": "パネル設定から証明書を設定",
      "setDefaultCertEmpty": "パネル用の証明書が設定されていません。先に設定から指定してください。",
      "streamTab": "ストリーム",
      "securityTab": "セキュリティ",
      "sniffingTab": "スニッフィング",
      "sniffingMetadataOnly": "メタデータのみ",
      "sniffingRouteOnly": "ルーティングのみ",
      "sniffingIpsExcluded": "除外する IP",
      "sniffingDomainsExcluded": "除外するドメイン",
      "decryption": "復号",
      "encryption": "暗号化",
      "vlessAuthX25519": "X25519 認証",
      "vlessAuthMlkem768": "ML-KEM-768 認証",
      "vlessAuthCustom": "カスタム",
      "vlessAuthSelected": "選択中: {auth}",
      "advanced": {
        "title": "インバウンド JSON セクション",
        "subtitle": "インバウンド全体の JSON と、settings、sniffing、streamSettings 用の専用エディター。",
        "all": "すべて",
        "allHelp": "すべてのフィールドを含むインバウンドオブジェクト全体を 1 つのエディターで編集します。",
        "settings": "設定",
        "settingsHelp": "Xray settings ブロックのラッパー:",
        "sniffing": "Sniffing",
        "sniffingHelp": "Xray sniffing ブロックのラッパー:",
        "stream": "Stream",
        "streamHelp": "Xray stream ブロックのラッパー:",
        "jsonErrorPrefix": "高度な JSON"
      },
      "telegramDesc": "TelegramチャットIDを提供してください。（ボットで'/id'コマンドを使用）または（{'@'}userinfobot）",
      "subscriptionDesc": "サブスクリプションURLを見つけるには、“詳細情報”に移動してください。また、複数のクライアントに同じ名前を使用することができます。",
      "same": "同じ",
      "inboundData": "インバウンドデータ",
      "exportInbound": "インバウンドルールをエクスポート",
      "import": "インポート",
      "importInbound": "インバウンドルールをインポート",
      "periodicTrafficResetTitle": "トラフィックリセット",
      "periodicTrafficResetDesc": "指定された間隔でトラフィックカウンタを自動的にリセット",
      "lastReset": "最後のリセット",
      "periodicTrafficReset": {
        "never": "なし",
        "daily": "毎日",
        "weekly": "毎週",
        "monthly": "毎月",
        "hourly": "毎時"
      },
      "toasts": {
        "obtain": "取得",
        "updateSuccess": "更新が成功しました",
        "logCleanSuccess": "ログがクリアされました",
        "inboundsUpdateSuccess": "インバウンドが正常に更新されました",
        "inboundUpdateSuccess": "インバウンドが正常に更新されました",
        "inboundCreateSuccess": "インバウンドが正常に作成されました",
        "inboundDeleteSuccess": "インバウンドが正常に削除されました",
        "inboundClientAddSuccess": "インバウンドクライアントが追加されました",
        "inboundClientDeleteSuccess": "インバウンドクライアントが削除されました",
        "inboundClientUpdateSuccess": "インバウンドクライアントが更新されました",
        "delDepletedClientsSuccess": "すべての枯渇したクライアントが削除されました",
        "resetAllClientTrafficSuccess": "クライアントのすべてのトラフィックがリセットされました",
        "resetAllTrafficSuccess": "すべてのトラフィックがリセットされました",
        "resetInboundClientTrafficSuccess": "トラフィックがリセットされました",
        "resetInboundTrafficSuccess": "受信トラフィックがリセットされました",
        "trafficGetError": "トラフィックの取得中にエラーが発生しました",
        "getNewX25519CertError": "X25519証明書の取得中にエラーが発生しました。",
        "getNewmldsa65Error": "mldsa65証明書の取得中にエラーが発生しました。",
        "getNewVlessEncError": "VlessEnc証明書の取得中にエラーが発生しました。"
      },
      "form": {
        "moveUp": "上へ",
        "moveDown": "下へ",
        "addAll": "すべて追加",
        "addAllFallbackTooltip": "まだ接続されていないすべての対象インバウンドに対し fallback 行を追加",
        "peers": "Peers",
        "addPeer": "peer を追加",
        "keepAlive": "Keep-alive",
        "autoSystemRoutesTooltip": "Windows のみ。CIDR はシステムルーティングテーブルに自動追加され、一致するトラフィックは TUN を経由します。",
        "autoOutboundsInterface": "自動アウトバウンドインターフェース",
        "autoOutboundsInterfaceTooltip": "アウトバウンドトラフィック用の物理インターフェース。検出には 'auto' を使用; Auto system routes が設定されていると自動的に有効。",
        "rewriteAddress": "アドレス書き換え",
        "rewritePort": "ポート書き換え",
        "allowedNetwork": "許可されたネットワーク",
        "followRedirect": "リダイレクトに従う",
        "accounts": "アカウント",
        "allowTransparent": "透過を許可",
        "encryptionMethod": "暗号化方式",
        "visionTestseed": "Vision testseed",
        "version": "バージョン",
        "udpIdleTimeout": "UDP idle timeout (秒)",
        "masquerade": "Masquerade",
        "type": "種類",
        "upstreamUrl": "Upstream URL",
        "rewriteHost": "Host 書き換え",
        "skipTlsVerify": "TLS 検証をスキップ",
        "directory": "ディレクトリ",
        "statusCode": "ステータスコード",
        "body": "Body",
        "headers": "ヘッダー",
        "proxyProtocol": "Proxy Protocol",
        "requestVersion": "リクエストバージョン",
        "requestMethod": "リクエストメソッド",
        "requestPath": "リクエストパス",
        "requestHeaders": "リクエストヘッダー",
        "responseVersion": "レスポンスバージョン",
        "responseStatus": "レスポンスステータス",
        "responseReason": "レスポンス理由",
        "responseHeaders": "レスポンスヘッダー",
        "heartbeatPeriod": "ハートビート間隔",
        "serviceName": "サービス名",
        "authority": "Authority",
        "multiMode": "Multi Mode",
        "maxBufferedUpload": "最大バッファアップロード",
        "maxUploadSize": "最大アップロードサイズ (バイト)",
        "streamUpServer": "Stream-Up Server",
        "serverMaxHeaderBytes": "サーバー最大ヘッダーバイト",
        "paddingBytes": "Padding バイト",
        "uplinkHttpMethod": "Uplink HTTP メソッド",
        "paddingObfsMode": "Padding 難読化モード",
        "paddingKey": "Padding Key",
        "paddingHeader": "Padding Header",
        "paddingPlacement": "Padding 配置",
        "paddingMethod": "Padding 方法",
        "sessionPlacement": "Session Placement",
        "sessionKey": "Session Key",
        "sequencePlacement": "Sequence Placement",
        "sequenceKey": "Sequence Key",
        "uplinkDataPlacement": "Uplink Data Placement",
        "uplinkDataKey": "Uplink Data Key",
        "noSseHeader": "SSE ヘッダーなし",
        "ttiMs": "TTI (ms)",
        "uplinkMbps": "アップリンク (MB/s)",
        "downlinkMbps": "ダウンリンク (MB/s)",
        "cwndMultiplier": "CWND 倍率",
        "maxSendingWindow": "最大送信ウィンドウ",
        "externalProxy": "外部プロキシ",
        "sniPlaceholder": "SNI (デフォルトは host)",
        "fingerprint": "Fingerprint",
        "defaultOption": "デフォルト",
        "routeMark": "Route Mark",
        "tcpKeepAliveInterval": "TCP Keep Alive Interval",
        "tcpKeepAliveIdle": "TCP Keep Alive Idle",
        "tcpMaxSeg": "TCP Max Seg",
        "tcpUserTimeout": "TCP User Timeout",
        "tcpWindowClamp": "TCP Window Clamp",
        "tcpFastOpen": "TCP Fast Open",
        "multipathTcp": "Multipath TCP",
        "penetrate": "Penetrate",
        "v6Only": "V6 のみ",
        "tcpCongestion": "TCP Congestion",
        "dialerProxy": "Dialer Proxy",
        "trustedXForwardedFor": "信頼できる X-Forwarded-For",
        "addressPortStrategy": "アドレス+ポート戦略",
        "tryDelayMs": "試行遅延 (ms)",
        "prioritizeIPv6": "IPv6 優先",
        "interleave": "Interleave",
        "maxConcurrentTry": "最大同時試行",
        "customSockopt": "カスタム sockopt",
        "addCustomOption": "カスタムオプション追加",
        "serverNameIndication": "SNI",
        "cipherSuites": "Cipher Suites",
        "autoOption": "自動",
        "minMaxVersion": "最小/最大バージョン",
        "rejectUnknownSni": "未知の SNI を拒否",
        "disableSystemRoot": "System Root を無効化",
        "sessionResumption": "セッション再開",
        "oneTimeLoading": "一度のみ読み込み",
        "usageOption": "使用オプション",
        "buildChain": "Build Chain",
        "echKey": "ECH key",
        "echConfig": "ECH config",
        "pinnedPeerCertSha256": "ピン留めピア証明書 SHA-256",
        "pinnedPeerCertSha256Tip": "ピア証明書の Base64 エンコード SHA-256 ハッシュ。パネルのみ — サーバーの xray 設定には書き込まれませんが、共有リンクには含まれ、クライアントが証明書をピン留めできます。",
        "pinnedPeerCertSha256Placeholder": "Base64 ハッシュ、カンマ区切り",
        "generateRandomPin": "ランダムハッシュを生成",
        "getNewEchCert": "新しい ECH 証明書を取得",
        "show": "表示",
        "xver": "Xver",
        "target": "ターゲット",
        "maxTimeDiff": "最大時間差 (ms)",
        "minClientVer": "最小クライアントバージョン",
        "maxClientVer": "最大クライアントバージョン",
        "shortIds": "Short IDs",
        "spiderX": "SpiderX",
        "getNewCert": "新しい証明書を取得",
        "mldsa65Seed": "mldsa65 Seed",
        "mldsa65Verify": "mldsa65 Verify",
        "getNewSeed": "新しい Seed を取得"
      },
      "info": {
        "mode": "モード",
        "grpcServiceName": "grpc serviceName",
        "grpcMultiMode": "grpc multiMode",
        "interfaceName": "インターフェース名",
        "mtu": "MTU",
        "gateway": "Gateway",
        "dns": "DNS",
        "outboundsInterface": "アウトバウンドインターフェース",
        "autoSystemRoutes": "自動システムルート",
        "followRedirect": "FollowRedirect",
        "auth": "Auth",
        "noKernelTun": "非カーネル TUN",
        "keepAlive": "Keep alive",
        "peerNumber": "Peer {n}",
        "peerNumberConfig": "Peer {n} 設定"
      },
      "stream": {
        "general": {
          "request": "リクエスト",
          "response": "レスポンス",
          "name": "名前",
          "value": "値"
        },
        "tcp": {
          "version": "バージョン",
          "method": "方法",
          "path": "パス",
          "status": "ステータス",
          "statusDescription": "ステータス説明",
          "requestHeader": "リクエストヘッダー",
          "responseHeader": "レスポンスヘッダー"
        }
      }
    },
    "clients": {
      "add": "クライアントを追加",
      "edit": "クライアントを編集",
      "submitAdd": "クライアントを追加",
      "submitEdit": "変更を保存",
      "clientCount": "クライアント数",
      "bulk": "一括追加",
      "copyFromInbound": "インバウンドからクライアントをコピー",
      "copyToInbound": "コピー先",
      "copySelected": "選択をコピー",
      "copySource": "コピー元",
      "copyEmailPreview": "生成されるメールのプレビュー",
      "copySelectSourceFirst": "まずコピー元のインバウンドを選択してください。",
      "copyResult": "コピー結果",
      "copyResultSuccess": "コピーに成功しました",
      "copyResultNone": "コピーする対象がありません。クライアントが選択されていないか、コピー元が空です",
      "copyResultErrors": "コピーエラー",
      "copyFlowLabel": "新規クライアントの Flow (VLESS)",
      "copyFlowHint": "コピーされる全クライアントに適用されます。空欄でスキップします。",
      "selectAll": "すべて選択",
      "clearAll": "すべてクリア",
      "method": "メソッド",
      "first": "最初",
      "last": "最後",
      "ipLog": "IP ログ",
      "prefix": "プレフィックス",
      "postfix": "サフィックス",
      "delayedStart": "初回使用から開始",
      "expireDays": "期間",
      "days": "日",
      "renew": "自動更新",
      "renewDesc": "有効期限切れ後に自動更新します。(0 = 無効) (単位: 日)",
      "searchPlaceholder": "メール、コメント、sub ID、UUID、パスワード、auth を検索…",
      "filterTitle": "クライアントをフィルタ",
      "clearAllFilters": "すべてクリア",
      "sortOldest": "古い順",
      "sortNewest": "新しい順",
      "sortRecentlyUpdated": "最近更新",
      "sortRecentlyOnline": "最近オンライン",
      "sortEmailAZ": "メール A→Z",
      "sortEmailZA": "メール Z→A",
      "sortMostTraffic": "トラフィック多い順",
      "sortHighestRemaining": "残量多い順",
      "sortExpiringSoonest": "もうすぐ期限切れ",
      "has": "あり",
      "hasNot": "なし",
      "title": "クライアント",
      "actions": "操作",
      "totalGB": "送受信合計 (GB)",
      "expiryTime": "有効期限",
      "addClients": "クライアントを追加",
      "limitIp": "IP 制限",
      "password": "パスワード",
      "subId": "サブスクリプション ID",
      "online": "オンライン",
      "email": "メール",
      "group": "グループ",
      "groupDesc": "関連クライアントをまとめる論理ラベル(チーム、顧客、地域など)。ツールバーからフィルタ可能。",
      "groupPlaceholder": "例: customer-a",
      "comment": "コメント",
      "traffic": "トラフィック",
      "offline": "オフライン",
      "addTitle": "クライアントを追加",
      "qrCode": "QR コード",
      "moreInformation": "詳細情報",
      "delete": "削除",
      "reset": "トラフィックをリセット",
      "editTitle": "クライアントを編集",
      "client": "クライアント",
      "enabled": "有効",
      "remaining": "残量",
      "duration": "期間",
      "attachedInbounds": "関連付けされたインバウンド",
      "selectInbound": "1 つ以上のインバウンドを選択",
      "noSubId": "このクライアントには subId がなく、共有可能なリンクはありません。",
      "noLinks": "共有可能なリンクがありません — まずこのクライアントを対応するプロトコルのインバウンドに関連付けてください。",
      "link": "リンク",
      "resetNotPossible": "まずこのクライアントをインバウンドに関連付けてください。",
      "general": "一般",
      "resetAllTraffics": "すべてのクライアントのトラフィックをリセット",
      "resetAllTrafficsTitle": "すべてのクライアントのトラフィックをリセットしますか?",
      "resetAllTrafficsContent": "すべてのクライアントの送受信カウンターがゼロにリセットされます。クォータと有効期限には影響しません。元に戻せません。",
      "deleteConfirmTitle": "クライアント {email} を削除しますか?",
      "deleteConfirmContent": "クライアントを関連付けされたすべてのインバウンドから削除し、トラフィック記録も破棄します。元に戻せません。",
      "deleteSelected": "削除 ({count})",
      "adjustSelected": "調整 ({count})",
      "subLinksSelected": "サブリンク ({count})",
      "addToGroupTitle": "{count} クライアントをグループに追加",
      "addToGroupTooltip": "既存のグループを選ぶか新しい名前を入力してください。Ungroup で現在のグループから外せます。",
      "addToGroupPlaceholder": "グループ名",
      "addToGroupSuccessToast": "{count} クライアントを {group} に追加しました",
      "ungroupSuccessToast": "{count} クライアントのグループをクリアしました",
      "ungroup": "グループ解除",
      "ungroupConfirmTitle": "{count} クライアントをグループから外しますか?",
      "ungroupConfirmContent": "選択したクライアントのグループラベルをクリアします。クライアント自体は保持されます (完全に削除するには Delete を使用)。",
      "addToGroup": "グループに追加",
      "attach": "アタッチ",
      "adjust": "調整",
      "subLinks": "サブリンク",
      "selectedCount": "{count} 選択中",
      "attachSelected": "アタッチ ({count})",
      "attachToInboundsTitle": "{count} クライアントをインバウンドにアタッチ",
      "attachToInboundsDesc": "選択した {count} クライアント(同じ UUID/パスワードと共有トラフィック)を選択したインバウンドにアタッチします。既存のアタッチは維持されます。",
      "attachToInboundsTargets": "ターゲットインバウンド",
      "attachToInboundsNoTargets": "アタッチ可能なマルチユーザーインバウンドがありません。",
      "detachSelected": "デタッチ ({count})",
      "detach": "デタッチ",
      "detachFromInboundsTitle": "{count} クライアントをインバウンドからデタッチ",
      "detachFromInboundsDesc": "選択した {count} クライアントを選択したインバウンドから外します。アタッチされていなかったペアは黙ってスキップされます。クライアントレコードは保持されます (完全に削除するには Delete を使用)。",
      "detachFromInboundsTargets": "デタッチ対象のインバウンド",
      "detachFromInboundsNoTargets": "マルチユーザーインバウンドがありません。",
      "detachFromInboundsResult": "デタッチ {detached}、スキップ {skipped}。",
      "detachFromInboundsResultMixed": "デタッチ {detached}、スキップ {skipped}、エラー {errors}。",
      "subLinksTitle": "サブリンク ({count})",
      "subLinkColumn": "サブスクリプション URL",
      "subJsonLinkColumn": "サブスクリプション JSON URL",
      "subLinksCopyAll": "すべてコピー",
      "subLinksCopiedAll": "{count} リンクをコピーしました",
      "subLinksEmpty": "選択したクライアントにはサブスクリプション ID がありません。",
      "subLinksDisabled": "サブスクリプションサービスは無効です。",
      "subLinksDisabledHint": "リンクを生成するにはパネル設定 → サブスクリプションで有効にしてください。",
      "bulkDeleteConfirmTitle": "{count} 件のクライアントを削除しますか?",
      "bulkDeleteConfirmContent": "選択された各クライアントを関連付けされたすべてのインバウンドから削除し、トラフィック記録も破棄します。元に戻せません。",
      "bulkAdjustTitle": "{count} 件のクライアントを調整",
      "bulkAdjustHint": "正の値は延長、負の値は短縮します。無期限の有効期限または無制限のトラフィックを持つクライアントは、その項目についてスキップされます。",
      "bulkAdjustNothing": "適用する前に日数またはトラフィックを設定してください。",
      "addDays": "日数を追加",
      "addTrafficGB": "トラフィックを追加 (GB)",
      "delDepleted": "使い切ったクライアントを削除",
      "delDepletedConfirmTitle": "使い切ったクライアントを削除しますか?",
      "delDepletedConfirmContent": "トラフィック上限に達したか有効期限が切れたクライアントをすべて削除します。元に戻せません。",
      "auth": "Auth",
      "hysteriaAuth": "Hysteria Auth",
      "uuid": "UUID",
      "flow": "Flow",
      "vmessSecurity": "VMess セキュリティ",
      "reverseTag": "Reverse tag",
      "reverseTagPlaceholder": "任意の Reverse tag",
      "telegramId": "Telegram ユーザー ID",
      "telegramIdPlaceholder": "数値の Telegram ユーザー ID (0 = なし)",
      "created": "作成日",
      "updated": "更新日",
      "ipLimit": "IP 制限",
      "toasts": {
        "deleted": "クライアントを削除しました",
        "trafficReset": "トラフィックをリセットしました",
        "allTrafficsReset": "すべてのクライアントのトラフィックをリセットしました",
        "bulkDeleted": "{count} 件のクライアントを削除しました",
        "bulkDeletedMixed": "{ok} 件削除、{failed} 件失敗",
        "bulkCreated": "{count} 件のクライアントを作成しました",
        "bulkCreatedMixed": "{ok} 件作成、{failed} 件失敗",
        "bulkAdjusted": "{count} 件のクライアントを調整しました",
        "bulkAdjustedMixed": "{ok} 件調整、{skipped} 件スキップ",
        "delDepleted": "使い切った {count} 件のクライアントを削除しました"
      }
    },
    "groups": {
      "title": "グループ",
      "name": "名前",
      "clientCount": "グループ内のクライアント",
      "totalGroups": "グループ合計",
      "totalGroupedClients": "グループのあるクライアント",
      "emptyGroups": "空のグループ",
      "addGroup": "グループ追加",
      "createSuccess": "グループ「{name}」を作成しました。",
      "rename": "名前変更",
      "renameTitle": "{name} の名前を変更",
      "renameCollision": "「{name}」という名前のグループは既に存在します。",
      "renameSuccess": "{count} クライアントのグループ名を変更しました。",
      "deleteConfirmTitle": "グループ {name} を削除?",
      "deleteConfirmContent": "これはグループを削除し、{count} クライアントのラベルをクリアします。クライアント自体は削除されません。",
      "deleteSuccess": "{count} クライアントのグループをクリアしました。",
      "resetTraffic": "トラフィックをリセット",
      "resetConfirmTitle": "グループ {name} のトラフィックをリセット?",
      "resetConfirmContent": "このグループ内のすべての {count} クライアントの up/down をゼロにします。",
      "resetSuccess": "{count} クライアントのトラフィックをリセットしました。",
      "adjustSuccess": "{name} 内の {count} クライアントを調整しました。",
      "emptyForAction": "このグループにはまだクライアントがありません。",
      "deleteGroupOnly": "グループ削除 (クライアントは保持)",
      "deleteClients": "グループのクライアントを削除",
      "deleteClientsConfirmTitle": "{name} 内のすべてのクライアントを削除?",
      "deleteClientsConfirmContent": "これは {count} クライアントとそのトラフィック記録を永久に削除します。グループラベルもクリアされます。取り消せません。",
      "deleteClientsSuccess": "{count} クライアントを削除しました。",
      "deleteClientsMixed": "{ok} 削除、{failed} スキップ",
      "addToGroup": "クライアントを追加…",
      "addToGroupTitle": "グループ「{name}」にクライアントを追加",
      "addToGroupDesc": "このグループに追加するクライアントを選択してください。既存のインバウンドアタッチは保持され、グループラベルのみ変更されます。すでにこのグループにいるクライアントは表示されません。",
      "addToGroupEmpty": "追加可能な他のクライアントはありません。",
      "addToGroupResult": "{count} クライアントを {name} に追加しました。",
      "removeFromGroup": "クライアントを削除…",
      "removeFromGroupTitle": "グループ「{name}」からクライアントを削除",
      "removeFromGroupDesc": "このグループから外すメンバーを選択してください。クライアント自体は保持されます (完全に削除するには「グループのクライアントを削除」を使用)。",
      "removeFromGroupResult": "{count} クライアントを {name} から外しました。"
    },
    "nodes": {
      "title": "ノード",
      "addNode": "ノードを追加",
      "editNode": "ノード編集",
      "totalNodes": "ノード総数",
      "onlineNodes": "オンライン",
      "offlineNodes": "オフライン",
      "avgLatency": "平均レイテンシ",
      "name": "名前",
      "namePlaceholder": "例: de-frankfurt-1",
      "addressPlaceholder": "panel.example.com または 1.2.3.4",
      "remark": "備考",
      "scheme": "スキーム",
      "address": "アドレス",
      "port": "ポート",
      "basePath": "ベースパス",
      "apiToken": "API トークン",
      "apiTokenPlaceholder": "リモートパネルの設定ページから取得したトークン",
      "apiTokenHint": "リモートパネルでは、設定 → APIトークン でAPIトークンを確認できます。",
      "regenerate": "トークンを再生成",
      "regenerateConfirm": "再生成すると現在のトークンは無効になります。これを使用しているすべての中央パネルは更新されるまでアクセスできなくなります。続行しますか？",
      "allowPrivateAddress": "プライベートアドレスを許可",
      "allowPrivateAddressHint": "プライベートネットワークまたはVPN上のノードにのみ有効にします。",
      "enable": "有効",
      "status": "ステータス",
      "cpu": "CPU",
      "mem": "メモリ",
      "uptime": "稼働時間",
      "latency": "レイテンシ",
      "lastHeartbeat": "最後のハートビート",
      "xrayVersion": "Xrayバージョン",
      "panelVersion": "パネルのバージョン",
      "actions": "操作",
      "probe": "今すぐプローブ",
      "testConnection": "接続テスト",
      "connectionOk": "接続OK ({ms} ms)",
      "connectionFailed": "接続に失敗しました",
      "never": "なし",
      "justNow": "たった今",
      "deleteConfirmTitle": "ノード「{name}」を削除しますか？",
      "deleteConfirmContent": "ノードの監視を停止します。リモートパネル自体には影響しません。",
      "statusValues": {
        "online": "オンライン",
        "offline": "オフライン",
        "unknown": "不明"
      },
      "toasts": {
        "list": "ノードの読み込みに失敗しました",
        "obtain": "ノードの読み込みに失敗しました",
        "add": "ノードを追加",
        "update": "ノードを更新",
        "delete": "ノードを削除",
        "deleted": "ノードを削除しました",
        "test": "接続テスト",
        "fillRequired": "名前、アドレス、ポート、APIトークンは必須です",
        "probeFailed": "プローブに失敗しました"
      }
    },
    "settings": {
      "title": "パネル設定",
      "save": "保存",
      "infoDesc": "ここでのすべての変更は、保存してパネルを再起動する必要があります",
      "restartPanel": "パネルを再起動",
      "restartPanelDesc": "パネルを再起動してもよろしいですか？再起動後にパネルにアクセスできない場合は、サーバーでパネルログを確認してください",
      "restartPanelSuccess": "パネルの再起動に成功しました",
      "actions": "操作",
      "resetDefaultConfig": "デフォルト設定にリセット",
      "panelSettings": "一般",
      "securitySettings": "セキュリティ設定",
      "securityWarnings": "セキュリティ警告",
      "panelExposed": "パネルが露出している可能性があります:",
      "warnHttp": "パネルが平文 HTTP で提供されています — 本番環境には TLS を設定してください。",
      "warnDefaultPort": "デフォルトポート 2053 はよく知られています — ランダムなポートに変更してください。",
      "warnDefaultBasePath": "デフォルトのベースパス \"/\" はよく知られています — ランダムなパスに変更してください。",
      "warnDefaultSubPath": "デフォルトのサブスクリプションパス \"/sub/\" はよく知られています — 変更してください。",
      "warnDefaultJsonPath": "デフォルトの JSON サブスクリプションパス \"/json/\" はよく知られています — 変更してください。",
      "TGBotSettings": "Telegram Bot",
      "panelListeningIP": "パネル監視IP",
      "panelListeningIPDesc": "デフォルトではすべてのIPを監視する",
      "panelListeningDomain": "パネル監視ドメイン",
      "panelListeningDomainDesc": "デフォルトで空白の場合、すべてのドメインとIPアドレスを監視する",
      "panelPort": "パネル監視ポート",
      "panelPortDesc": "再起動で有効",
      "publicKeyPath": "パネル証明書公開鍵ファイルパス",
      "publicKeyPathDesc": "'/'で始まる絶対パスを入力",
      "privateKeyPath": "パネル証明書秘密鍵ファイルパス",
      "privateKeyPathDesc": "'/'で始まる絶対パスを入力",
      "panelUrlPath": "URI パス",
      "panelUrlPathDesc": "'/'で始まり、'/'で終わる必要があります",
      "pageSize": "ページサイズ",
      "pageSizeDesc": "インバウンドテーブルのページサイズを定義します。0を設定すると無効化されます",
      "panelProxy": "パネルネットワークプロキシ",
      "panelProxyDesc": "パネル自体のアウトバウンドリクエスト (geo 更新、Xray/パネルバージョンチェック、Telegram) をこのプロキシ経由でルーティングし、サーバー側の GitHub/Telegram フィルタリングを回避します。socks5:// または http(s):// を受け付けます。例: ローカルの Xray SOCKS インバウンド。直接接続するには空のままにします。",
      "remarkModel": "備考モデルと区切り記号",
      "datepicker": "日付ピッカー",
      "datepickerPlaceholder": "日付を選択",
      "datepickerDescription": "日付選択カレンダーで有効期限を指定する",
      "sampleRemark": "備考の例",
      "oldUsername": "旧ユーザー名",
      "currentPassword": "旧パスワード",
      "newUsername": "新しいユーザー名",
      "newPassword": "新しいパスワード",
      "telegramBotEnable": "Telegramボットを有効にする",
      "telegramBotEnableDesc": "Telegramボット機能を有効にする",
      "telegramToken": "Telegram トークン",
      "telegramTokenDesc": "'{'@'}BotFather'から取得したTelegramボットトークン",
      "telegramProxy": "SOCKS プロキシ",
      "telegramProxyDesc": "SOCKS5プロキシを有効にしてTelegramに接続する（ガイドに従って設定を調整）",
      "telegramAPIServer": "Telegram API サーバー",
      "telegramAPIServerDesc": "使用するTelegram APIサーバー。空白の場合はデフォルトサーバーを使用する",
      "telegramChatId": "管理者チャットID",
      "telegramChatIdDesc": "Telegram管理者チャットID（複数の場合はカンマで区切る）{'@'}userinfobotで取得するか、ボットで'/id'コマンドを使用して取得する",
      "telegramNotifyTime": "通知時間",
      "telegramNotifyTimeDesc": "定期的なTelegramボット通知時間を設定する（crontab時間形式を使用）",
      "tgNotifyBackup": "データベースバックアップ",
      "tgNotifyBackupDesc": "レポート付きのデータベースバックアップファイルを送信",
      "tgNotifyLogin": "ログイン通知",
      "tgNotifyLoginDesc": "誰かがパネルにログインしようとしたときに、ユーザー名、IPアドレス、時間を表示する",
      "sessionMaxAge": "セッション期間",
      "sessionMaxAgeDesc": "ログイン状態を保持する期間（単位：分）",
      "expireTimeDiff": "有効期限通知のしきい値",
      "expireTimeDiffDesc": "このしきい値に達した場合、有効期限に関する通知を受け取る（単位：日）",
      "trafficDiff": "トラフィック消耗しきい値",
      "trafficDiffDesc": "このしきい値に達した場合、トラフィック消耗に関する通知を受け取る（単位：GB）",
      "tgNotifyCpu": "CPU負荷通知しきい値",
      "tgNotifyCpuDesc": "CPU負荷がこのしきい値を超えた場合、通知を受け取る（単位：%）",
      "timeZone": "タイムゾーン",
      "timeZoneDesc": "定時タスクはこのタイムゾーンの時間に従って実行される",
      "subSettings": "サブスクリプション設定",
      "subEnable": "サブスクリプションサービスを有効にする",
      "subEnableDesc": "サブスクリプションサービス機能を有効にする",
      "subJsonEnable": "JSON サブスクリプションのエンドポイントを個別に有効/無効にする。",
      "subJsonEnableTitle": "JSON サブスクリプション",
      "subClashEnableTitle": "Clash / Mihomo サブスクリプション",
      "subTitle": "サブスクリプションタイトル",
      "subTitleDesc": "VPNクライアントに表示されるタイトル",
      "subSupportUrl": "サポートURL",
      "subSupportUrlDesc": "VPNクライアントに表示されるテクニカルサポートへのリンク",
      "subProfileUrl": "プロフィールURL",
      "subProfileUrlDesc": "VPNクライアントに表示されるWebサイトへのリンク",
      "subAnnounce": "お知らせ",
      "subAnnounceDesc": "VPNクライアントに表示されるお知らせのテキスト",
      "subEnableRouting": "ルーティングを有効化",
      "subEnableRoutingDesc": "VPNクライアントでルーティングを有効にするためのグローバル設定。(Happのみ)",
      "subRoutingRules": "ルーティングルール",
      "subRoutingRulesDesc": "VPNクライアントのグローバルルーティングルール。(Happのみ)",
      "subListen": "監視IP",
      "subListenDesc": "サブスクリプションサービスが監視するIPアドレス（空白にするとすべてのIPを監視）",
      "subPort": "監視ポート",
      "subPortDesc": "サブスクリプションサービスが監視するポート番号（使用されていないポートである必要があります）",
      "subCertPath": "公開鍵パス",
      "subCertPathDesc": "サブスクリプションサービスで使用する公開鍵ファイルのパス（'/'で始まる）",
      "subKeyPath": "秘密鍵パス",
      "subKeyPathDesc": "サブスクリプションサービスで使用する秘密鍵ファイルのパス（'/'で始まる）",
      "subPath": "URI パス",
      "subPathDesc": "サブスクリプションサービスで使用するURIパス（'/'で始まり、'/'で終わる）",
      "subDomain": "監視ドメイン",
      "subDomainDesc": "サブスクリプションサービスが監視するドメイン（空白にするとすべてのドメインとIPを監視）",
      "subUpdates": "更新間隔",
      "subUpdatesDesc": "クライアントアプリケーションでサブスクリプションURLの更新間隔（単位：時間）",
      "subEncrypt": "エンコード",
      "subEncryptDesc": "サブスクリプションサービスが返す内容をBase64エンコードする",
      "subShowInfo": "利用情報を表示",
      "subShowInfoDesc": "クライアントアプリで残りのトラフィックと日付情報を表示する",
      "subEmailInRemark": "名前にメールを含める",
      "subEmailInRemarkDesc": "サブスクリプションプロファイル名にクライアントのメールアドレスを含めます。",
      "subURI": "リバースプロキシURI",
      "subURIDesc": "プロキシ後ろのサブスクリプションURLのURIパスに使用する",
      "externalTrafficInformEnable": "外部トラフィック情報",
      "externalTrafficInformEnableDesc": "トラフィック更新ごとに外部 API に通知。",
      "externalTrafficInformURI": "外部トラフィック通知 URI",
      "externalTrafficInformURIDesc": "トラフィックの更新ごとに外部 API に通知します。",
      "restartXrayOnClientDisable": "自動無効化後に Xray を再起動",
      "restartXrayOnClientDisableDesc": "有効期限切れまたはトラフィック上限でクライアントが自動的に無効化されたとき、Xray を再起動します。",
      "fragment": "フラグメント",
      "fragmentDesc": "TLS helloパケットのフラグメントを有効にする",
      "fragmentSett": "設定",
      "noisesDesc": "Noisesを有効にする",
      "noisesSett": "Noises設定",
      "trustedProxyCidrs": "信頼できるプロキシ CIDR",
      "trustedProxyCidrsDesc": "転送される host、proto、クライアント IP ヘッダーを設定可能な IP/CIDR (カンマ区切り)。",
      "ldap": {
        "enable": "LDAP 同期を有効化",
        "host": "LDAP host",
        "port": "LDAP ポート",
        "useTls": "TLS (LDAPS) を使用",
        "bindDn": "Bind DN",
        "passwordConfigured": "設定済み;現在のパスワードを保持するには空のままにします。",
        "passwordUnconfigured": "未設定。",
        "passwordPlaceholder": "設定済み — 置き換えるには新しい値を入力",
        "baseDn": "Base DN",
        "userFilter": "ユーザーフィルター",
        "userAttr": "ユーザー属性 (username/email)",
        "vlessField": "VLESS flag 属性",
        "flagField": "汎用 flag 属性 (任意)",
        "flagFieldDesc": "設定すると VLESS flag を上書きします — 例: shadowInactive。",
        "truthyValues": "Truthy 値",
        "truthyValuesDesc": "カンマ区切り;デフォルト: true,1,yes,on",
        "invertFlag": "flag を反転",
        "invertFlagDesc": "属性が「無効」を意味する場合に有効化 (例: shadowInactive)。",
        "syncSchedule": "同期スケジュール",
        "syncScheduleDesc": "cron 風の文字列、例 @every 1m",
        "inboundTags": "インバウンドタグ",
        "inboundTagsDesc": "LDAP 同期がクライアントを自動作成/削除できるインバウンド。",
        "noInbounds": "インバウンドが見つかりません。先にインバウンドで作成してください。",
        "autoCreate": "クライアントを自動作成",
        "autoDelete": "クライアントを自動削除",
        "defaultTotalGb": "デフォルト合計 (GB)",
        "defaultExpiryDays": "デフォルト有効期限 (日)",
        "defaultIpLimit": "デフォルト IP 制限"
      },
      "subFormats": {
        "packets": "パケット",
        "length": "長さ",
        "interval": "間隔",
        "maxSplit": "最大分割",
        "noises": "ノイズ",
        "noiseItem": "ノイズ №{n}",
        "type": "種類",
        "packet": "パケット",
        "delayMs": "遅延 (ms)",
        "applyTo": "適用先",
        "addNoise": "+ ノイズ",
        "concurrency": "並行数",
        "xudpConcurrency": "xudp 並行数",
        "xudpUdp443": "xudp UDP 443"
      },
      "mux": "Mux",
      "muxDesc": "確立されたストリーム内で複数の独立したストリームを伝送する",
      "muxSett": "マルチプレクサ設定",
      "direct": "直接接続",
      "directDesc": "特定の国のドメインまたはIP範囲に直接接続する",
      "notifications": "通知",
      "certs": "証明書",
      "externalTraffic": "外部トラフィック",
      "dateAndTime": "日付と時刻",
      "proxyAndServer": "プロキシとサーバー",
      "intervals": "間隔",
      "information": "情報",
      "language": "言語",
      "telegramBotLanguage": "Telegram Botの言語",
      "security": {
        "admin": "管理者の資格情報",
        "twoFactor": "二段階認証",
        "twoFactorEnable": "2FAを有効化",
        "twoFactorEnableDesc": "セキュリティを強化するために追加の認証層を追加します。",
        "twoFactorModalSetTitle": "二段階認証を有効にする",
        "twoFactorModalDeleteTitle": "二段階認証を無効にする",
        "twoFactorModalSteps": "二段階認証を設定するには、次の手順を実行してください:",
        "twoFactorModalFirstStep": "1. 認証アプリでこのQRコードをスキャンするか、QRコード近くのトークンをコピーしてアプリに貼り付けます",
        "twoFactorModalSecondStep": "2. アプリからコードを入力してください",
        "twoFactorModalRemoveStep": "二段階認証を削除するには、アプリからコードを入力してください。",
        "twoFactorModalChangeCredentialsTitle": "認証情報の変更",
        "twoFactorModalChangeCredentialsStep": "管理者の認証情報を変更するには、アプリケーションからコードを入力してください。",
        "twoFactorModalSetSuccess": "二要素認証が正常に設定されました",
        "twoFactorModalDeleteSuccess": "二要素認証が正常に削除されました",
        "twoFactorModalError": "コードが間違っています",
        "show": "表示",
        "hide": "非表示",
        "apiTokenNew": "新規トークン",
        "apiTokenName": "名前",
        "apiTokenNamePlaceholder": "例: central-panel-a",
        "apiTokenNameRequired": "名前は必須です",
        "apiTokenEmpty": "トークンがまだありません — ボットやリモートパネルを認証するために作成してください。",
        "apiTokenDeleteWarning": "このトークンを使用しているクライアントは直ちに認証できなくなります。"
      },
      "toasts": {
        "modifySettings": "パラメーターが変更されました。",
        "getSettings": "パラメーターの取得中にエラーが発生しました",
        "modifyUserError": "管理者認証情報の変更中にエラーが発生しました。",
        "modifyUser": "管理者の認証情報を正常に変更しました。",
        "originalUserPassIncorrect": "旧ユーザー名または旧パスワードが間違っています",
        "userPassMustBeNotEmpty": "新しいユーザー名と新しいパスワードは空にできません",
        "getOutboundTrafficError": "送信トラフィックの取得エラー",
        "resetOutboundTrafficError": "送信トラフィックのリセットエラー"
      }
    },
    "xray": {
      "title": "Xray 設定",
      "save": "保存",
      "restart": "Xray を再起動",
      "restartSuccess": "Xrayの再起動に成功しました",
      "restartOutputTitle": "Xray 再起動の出力",
      "restartConfirmTitle": "xray を再起動?",
      "restartConfirmContent": "保存された構成で xray サービスを再ロードします。",
      "stopSuccess": "Xrayが正常に停止しました",
      "restartError": "Xrayの再起動中にエラーが発生しました。",
      "stopError": "Xrayの停止中にエラーが発生しました。",
      "basicTemplate": "基本設定",
      "advancedTemplate": "高度な設定",
      "generalConfigs": "一般設定",
      "generalConfigsDesc": "これらのオプションは一般設定を決定します",
      "logConfigs": "ログ",
      "logConfigsDesc": "ログはサーバーのパフォーマンスに影響を与える可能性があるため、必要な場合にのみ有効にすることをお勧めします",
      "blockConfigsDesc": "これらのオプションは、特定のプロトコルやウェブサイトへのユーザー接続をブロックします",
      "basicRouting": "基本ルーティング",
      "blockConnectionsConfigsDesc": "これらのオプションにより、特定のリクエスト元の国に基づいてトラフィックをブロックします。",
      "directConnectionsConfigsDesc": "直接接続により、特定のトラフィックが他のサーバーを経由しないようにします。",
      "blockips": "IPをブロック",
      "blockdomains": "ドメインをブロック",
      "directips": "直接IP",
      "directdomains": "直接ドメイン",
      "ipv4Routing": "IPv4 ルーティング",
      "ipv4RoutingDesc": "このオプションはIPv4のみを介してターゲットドメインへルーティングします",
      "warpRouting": "WARP ルーティング",
      "warpRoutingDesc": "注意：これらのオプションを使用する前に、パネルのGitHubの手順に従って、サーバーにsocks5プロキシモードでWARPをインストールしてください。WARPはCloudflareサーバー経由でトラフィックをウェブサイトにルーティングします。",
      "nordRouting": "NordVPN ルーティング",
      "nordRoutingDesc": "これらのオプションはNordVPN経由で特定の宛先にトラフィックをルーティングします。",
      "Template": "高度なXray設定テンプレート",
      "TemplateDesc": "最終的なXray設定ファイルはこのテンプレートに基づいて生成されます",
      "FreedomStrategy": "Freedom プロトコル戦略",
      "FreedomStrategyDesc": "Freedomプロトコル内のネットワークの出力戦略を設定する",
      "RoutingStrategy": "ルーティングドメイン戦略設定",
      "RoutingStrategyDesc": "DNS解決の全体的なルーティング戦略を設定する",
      "outboundTestUrl": "アウトバウンドテスト URL",
      "outboundTestUrlDesc": "アウトバウンド接続テストに使用する URL。既定値",
      "Torrent": "BitTorrent プロトコルをブロック",
      "Inbounds": "インバウンド",
      "InboundsDesc": "特定のクライアントからのトラフィックを受け入れる",
      "Outbounds": "アウトバウンド",
      "Balancers": "負荷分散",
      "balancerTagRequired": "タグは必須です",
      "balancerSelectorRequired": "アウトバウンドを少なくとも1つ選んでください",
      "OutboundsDesc": "アウトバウンドトラフィックの送信方法を設定する",
      "Routings": "ルーティングルール",
      "RoutingsDesc": "各ルールの優先順位が重要です",
      "completeTemplate": "すべて",
      "logLevel": "ログレベル",
      "logLevelDesc": "エラーログのレベルを指定し、記録する情報を示します",
      "accessLog": "アクセスログ",
      "accessLogDesc": "アクセスログのファイルパス。特殊値 'none' はアクセスログを無効にします",
      "errorLog": "エラーログ",
      "errorLogDesc": "エラーログのファイルパス。特殊値 'none' はエラーログを無効にします",
      "dnsLog": "DNS ログ",
      "dnsLogDesc": "DNSクエリのログを有効にするかどうか",
      "maskAddress": "アドレスをマスク",
      "maskAddressDesc": "IPアドレスをマスクし、有効にするとログに表示されるIPアドレスを自動的に置き換えます",
      "statistics": "統計",
      "statsInboundUplink": "インバウンドアップロード統計",
      "statsInboundUplinkDesc": "すべてのインバウンドプロキシのアップストリームトラフィックの統計収集を有効にします。",
      "statsInboundDownlink": "インバウンドダウンロード統計",
      "statsInboundDownlinkDesc": "すべてのインバウンドプロキシのダウンストリームトラフィックの統計収集を有効にします。",
      "statsOutboundUplink": "アウトバウンドアップロード統計",
      "statsOutboundUplinkDesc": "すべてのアウトバウンドプロキシのアップストリームトラフィックの統計収集を有効にします。",
      "statsOutboundDownlink": "アウトバウンドダウンロード統計",
      "statsOutboundDownlinkDesc": "すべてのアウトバウンドプロキシのダウンストリームトラフィックの統計収集を有効にします。",
      "rules": {
        "first": "最初",
        "last": "最後",
        "up": "上へ",
        "down": "下へ",
        "source": "ソース",
        "dest": "宛先アドレス",
        "inbound": "インバウンド",
        "outbound": "アウトバウンド",
        "balancer": "負荷分散",
        "info": "情報",
        "add": "ルール追加",
        "edit": "ルール編集",
        "useComma": "カンマ区切りの項目"
      },
      "routing": {
        "dragToReorder": "ドラッグして並べ替え"
      },
      "ruleForm": {
        "sourceIps": "送信元 IP",
        "sourcePort": "送信元ポート",
        "vlessRoute": "VLESS ルート",
        "attributes": "属性",
        "value": "値",
        "user": "ユーザー",
        "inboundTags": "インバウンドタグ",
        "outboundTag": "アウトバウンドタグ",
        "balancerTag": "バランサータグ",
        "balancerTagTooltip": "設定済みのロードバランサーの1つを通じてトラフィックをルーティング"
      },
      "outboundForm": {
        "tagDuplicate": "このタグは他のアウトバウンドで使用されています",
        "tagRequired": "タグは必須です",
        "tagPlaceholder": "一意のタグ",
        "localIpPlaceholder": "ローカル IP",
        "addressRequired": "アドレスは必須です",
        "portRequired": "ポートは必須です",
        "optional": "任意",
        "udpOverTcp": "UDP over TCP",
        "uotVersion": "UoT バージョン",
        "inboundTag": "インバウンドタグ",
        "inboundTagPlaceholder": "ルーティングルールで使うインバウンドタグ",
        "responseType": "レスポンスタイプ",
        "rewriteNetwork": "ネットワーク書き換え",
        "unchanged": "(変更なし)",
        "unchangedAddress": "(変更なし) 例: 1.1.1.1",
        "rules": "ルール",
        "ruleN": "ルール {n}",
        "action": "アクション",
        "redirect": "Redirect",
        "fragment": "Fragment",
        "finalRules": "最終ルール",
        "overrideXrayPrivateIp": "Xray のデフォルトプライベート IP ブロックを上書き",
        "blockDelay": "ブロック遅延 (ms)",
        "reverseSniffing": "逆 sniffing",
        "workers": "Workers",
        "reserved": "予約",
        "minUploadInterval": "最小アップロード間隔 (ms)",
        "maxUploadSizeBytes": "最大アップロードサイズ (バイト)",
        "uplinkChunkSize": "Uplink チャンクサイズ",
        "noGrpcHeader": "gRPC ヘッダーなし",
        "maxConcurrency": "最大同時実行数",
        "maxConnections": "最大接続数",
        "maxReuseTimes": "最大再利用回数",
        "maxRequestTimes": "最大リクエスト回数",
        "maxReusableSecs": "最大再利用秒数",
        "keepAlivePeriod": "keep alive 周期",
        "authPassword": "Auth パスワード",
        "visionTestpre": "Vision testpre",
        "serverNamePlaceholder": "サーバー名",
        "verifyPeerName": "peer 名を検証",
        "pinnedSha256": "Pinned SHA256",
        "shortId": "Short ID",
        "sockopts": "Sockopts",
        "keepAliveInterval": "keep alive 間隔",
        "markFwmark": "Mark (fwmark)",
        "interface": "インターフェース",
        "ipv6Only": "IPv6 のみ",
        "acceptProxyProtocol": "proxy protocol を受け入れる",
        "tcpUserTimeoutMs": "TCP user timeout (ms)",
        "tcpKeepAliveIdleS": "TCP keep-alive idle (秒)"
      },
      "outbound": {
        "addOutbound": "アウトバウンド追加",
        "addReverse": "リバース追加",
        "editOutbound": "アウトバウンド編集",
        "editReverse": "リバース編集",
        "reverseTag": "リバースタグ",
        "reverseTagDesc": "VLESSシンプルリバースプロキシのアウトバウンドタグ。無効にするには空欄にしてください。",
        "reverseTagPlaceholder": "アウトバウンドタグ（空欄で無効）",
        "tag": "タグ",
        "tagDesc": "一意のタグ",
        "address": "アドレス",
        "reverse": "リバース",
        "domain": "ドメイン",
        "type": "タイプ",
        "bridge": "Bridge",
        "portal": "Portal",
        "link": "リンク",
        "intercon": "インターコネクション",
        "settings": "設定",
        "accountInfo": "アカウント情報",
        "outboundStatus": "アウトバウンドステータス",
        "sendThrough": "送信経路",
        "test": "テスト",
        "testResult": "テスト結果",
        "testing": "接続をテスト中...",
        "testSuccess": "テスト成功",
        "testFailed": "テスト失敗",
        "testError": "アウトバウンドのテストに失敗しました",
        "testModeTooltip": "TCP: 高速 dial-only プローブ。HTTP: xray を経由した完全リクエスト。",
        "testAll": "すべてテスト",
        "nordvpn": "NordVPN",
        "accessToken": "アクセストークン",
        "country": "国",
        "server": "サーバー",
        "city": "都市",
        "allCities": "すべての都市",
        "privateKey": "秘密鍵",
        "load": "負荷"
      },
      "balancer": {
        "addBalancer": "負荷分散追加",
        "editBalancer": "負荷分散編集",
        "balancerStrategy": "戦略",
        "balancerSelectors": "セレクター",
        "tag": "タグ",
        "tagDesc": "一意のタグ",
        "tagDuplicate": "このタグは他のバランサーで使用されています",
        "tagPlaceholder": "一意のバランサータグ",
        "selector": "セレクター",
        "fallback": "Fallback",
        "expected": "期待値",
        "expectedPlaceholder": "最適ノード数",
        "maxRtt": "最大 RTT",
        "tolerance": "許容範囲",
        "baselines": "Baselines",
        "costs": "Costs",
        "balancerDesc": "balancerTagとoutboundTagは同時に使用できません。同時に使用された場合、outboundTagのみが有効になります。"
      },
      "wireguard": {
        "secretKey": "シークレットキー",
        "publicKey": "公開鍵",
        "allowedIPs": "許可されたIP",
        "endpoint": "エンドポイント",
        "psk": "共有キー",
        "domainStrategy": "ドメイン戦略"
      },
      "tun": {
        "nameDesc": "TUN インターフェースの名前。デフォルトは 'xray0' です",
        "mtuDesc": "最大伝送単位。データパケットの最大サイズ。デフォルトは 1500 です",
        "userLevel": "ユーザーレベル",
        "userLevelDesc": "このインバウンドを通じて確立されたすべての接続は、このユーザーレベルを使用します。デフォルトは 0 です"
      },
      "nord": {
        "accessToken": "Access token",
        "privateKey": "秘密鍵",
        "noServers": "選択した国のサーバーが見つかりません",
        "noPublicKey": "選択したサーバーは NordLynx 公開鍵を公開していません。",
        "outboundAdded": "NordVPN アウトバウンドを追加しました",
        "outboundUpdated": "NordVPN アウトバウンドを更新しました"
      },
      "warp": {
        "licenseError": "WARP ライセンスの設定に失敗しました。",
        "fetchFirst": "先に WARP 構成を取得してください。",
        "createAccount": "WARP アカウントを作成",
        "accessToken": "Access token",
        "deviceId": "デバイス ID",
        "licenseKey": "ライセンスキー",
        "privateKey": "秘密鍵",
        "deleteAccount": "アカウントを削除",
        "settings": "設定",
        "licenseKeyLabel": "WARP / WARP+ ライセンスキー",
        "key": "キー",
        "keyPlaceholder": "26文字の WARP+ キー",
        "accountInfo": "アカウント情報",
        "deviceName": "デバイス名",
        "deviceModel": "デバイスモデル",
        "deviceEnabled": "デバイス有効",
        "accountType": "アカウントタイプ",
        "role": "役割",
        "warpPlusData": "WARP+ データ",
        "quota": "クォータ",
        "usage": "使用量",
        "addOutbound": "アウトバウンドを追加"
      },
      "dns": {
        "enable": "DNSを有効にする",
        "enableDesc": "組み込みDNSサーバーを有効にする",
        "tag": "DNSインバウンドタグ",
        "tagDesc": "このタグはルーティングルールでインバウンドタグとして使用できます",
        "clientIp": "クライアントIP",
        "clientIpDesc": "DNSクエリ中に指定されたIPの位置をサーバーに通知するために使用されます",
        "disableCache": "キャッシュを無効にする",
        "disableCacheDesc": "DNSキャッシュを無効にします",
        "disableFallback": "フォールバックを無効にする",
        "disableFallbackDesc": "フォールバックDNSクエリを無効にします",
        "disableFallbackIfMatch": "一致した場合にフォールバックを無効にする",
        "disableFallbackIfMatchDesc": "DNSサーバーの一致するドメインリストにヒットした場合、フォールバックDNSクエリを無効にします",
        "enableParallelQuery": "並列クエリを有効にする",
        "enableParallelQueryDesc": "複数のサーバーへの並列DNSクエリを有効にして、より高速な解決を実現",
        "strategy": "クエリ戦略",
        "strategyDesc": "ドメイン名解決の全体的な戦略",
        "add": "サーバー追加",
        "edit": "サーバー編集",
        "domains": "ドメイン",
        "expectIPs": "期待されるIP",
        "unexpectIPs": "予期しないIP",
        "useSystemHosts": "システムのHostsを使用",
        "useSystemHostsDesc": "インストール済みシステムのhostsファイルを使用する",
        "serveStale": "期限切れキャッシュを使用",
        "serveStaleDesc": "バックグラウンドで更新中に期限切れキャッシュ結果を返す",
        "serveExpiredTTL": "期限切れTTL",
        "serveExpiredTTLDesc": "期限切れキャッシュエントリの有効期間（秒）。0 = 無期限",
        "timeoutMs": "タイムアウト (ms)",
        "skipFallback": "フォールバックをスキップ",
        "finalQuery": "最終クエリ",
        "hosts": "Hosts",
        "hostsAdd": "Host を追加",
        "hostsEmpty": "Host が定義されていません",
        "hostsDomain": "ドメイン (例: domain:example.com)",
        "hostsValues": "IP またはドメイン — 入力して Enter",
        "usePreset": "テンプレートを使用",
        "dnsPresetTitle": "DNSテンプレート",
        "dnsPresetFamily": "ファミリー",
        "clearAll": "すべて削除",
        "clearAllTitle": "すべての DNS サーバを削除しますか？",
        "clearAllConfirm": "リストからすべての DNS サーバが削除されます。この操作は元に戻せません。"
      },
      "fakedns": {
        "add": "フェイクDNS追加",
        "edit": "フェイクDNS編集",
        "ipPool": "IPプールサブネット",
        "poolSize": "プールサイズ"
      }
    }
  },
  "tgbot": {
    "keyboardClosed": "❌ キーボードを閉じました！",
    "noResult": "❗ 結果がありません！",
    "noQuery": "❌ クエリが見つかりません！コマンドを再利用してください！",
    "wentWrong": "❌ 何かがうまくいかなかった！",
    "noIpRecord": "❗ IPレコードがありません！",
    "noInbounds": "❗ インバウンドが見つかりません！",
    "unlimited": "♾ 無制限（リセット）",
    "add": "追加",
    "month": "月",
    "months": "ヶ月",
    "day": "日",
    "days": "日間",
    "hours": "時間",
    "minutes": "分",
    "unknown": "不明",
    "inbounds": "インバウンド",
    "clients": "クライアント",
    "offline": "🔴 オフライン",
    "online": "🟢 オンライン",
    "commands": {
      "unknown": "❗ 不明なコマンド",
      "pleaseChoose": "👇 選択してください：\r\n",
      "help": "🤖 このボットをご利用いただきありがとうございます！サーバーから特定のデータを提供し、必要な変更を行うことができます。\r\n\r\n",
      "start": "👋 こんにちは、<i>{{ .Firstname }}</i>。\r\n",
      "welcome": "🤖 <b>{{ .Hostname }}</b> 管理ボットへようこそ。\r\n",
      "status": "✅ ボットは正常に動作しています！",
      "usage": "❗ 検索するテキストを入力してください！",
      "getID": "🆔 あなたのIDは：<code>{{ .ID }}</code>",
      "helpAdminCommands": "Xray Coreを再起動するには：\r\n<code>/restart</code>\r\n\r\nクライアントの電子メールを検索するには：\r\n<code>/usage [電子メール]</code>\r\n\r\nインバウンド（クライアントの統計情報を含む）を検索するには：\r\n<code>/inbound [備考]</code>\r\n\r\nTelegramチャットID：\r\n<code>/id</code>",
      "helpClientCommands": "統計情報を検索するには、次のコマンドを使用してください：\r\n<code>/usage [電子メール]</code>\r\n\r\nTelegramチャットID：\r\n<code>/id</code>",
      "restartUsage": "\r\n\r\n<code>/restart</code>",
      "restartSuccess": "✅ 操作成功！",
      "restartFailed": "❗ 操作エラー。\r\n\r\n<code>エラー: {{ .Error }}</code>",
      "xrayNotRunning": "❗ Xray Core は動作していません。",
      "startDesc": "メインメニューを表示",
      "helpDesc": "ボットのヘルプ",
      "statusDesc": "ボットの状態を確認",
      "idDesc": "Telegram IDを表示"
    },
    "messages": {
      "cpuThreshold": "🔴 CPU使用率は{{ .Percent }}%、しきい値{{ .Threshold }}%を超えました",
      "selectUserFailed": "❌ ユーザーの選択に失敗しました！",
      "userSaved": "✅ Telegramユーザーが保存されました。",
      "loginSuccess": "✅ パネルに正常にログインしました。\r\n",
      "loginFailed": "❗️ パネルのログインに失敗しました。\r\n",
      "2faFailed": "2FAエラー",
      "report": "🕰 定期報告：{{ .RunTime }}\r\n",
      "datetime": "⏰ 日時：{{ .DateTime }}\r\n",
      "hostname": "💻 ホスト: {{ .Hostname }}\r\n",
      "version": "🚀 X-UI バージョン：{{ .Version }}\r\n",
      "xrayVersion": "📡 Xray バージョン: {{ .XrayVersion }}\r\n",
      "ipv6": "🌐 IPv6: {{ .IPv6 }}\r\n",
      "ipv4": "🌐 IPv4: {{ .IPv4 }}\r\n",
      "ip": "🌐 IP: {{ .IP }}\r\n",
      "ips": "🔢 IP:\r\n{{ .IPs }}\r\n",
      "serverUpTime": "⏳ サーバー稼働時間：{{ .UpTime }} {{ .Unit }}\r\n",
      "serverLoad": "📈 サーバー負荷：{{ .Load1 }}, {{ .Load2 }}, {{ .Load3 }}\r\n",
      "serverMemory": "📋 RAM: {{ .Current }}/{{ .Total }}\r\n",
      "tcpCount": "🔹 TCP: {{ .Count }}\r\n",
      "udpCount": "🔸 UDP: {{ .Count }}\r\n",
      "traffic": "🚦 トラフィック：{{ .Total }} (↑{{ .Upload }},↓{{ .Download }})\r\n",
      "xrayStatus": "ℹ️ ステータス: {{ .State }}\r\n",
      "username": "👤 ユーザー名：{{ .Username }}\r\n",
      "reason": "❗️ 理由：{{ .Reason }}\r\n",
      "time": "⏰ 時間：{{ .Time }}\r\n",
      "inbound": "📍 インバウンド: {{ .Remark }}\r\n",
      "port": "🔌 ポート: {{ .Port }}\r\n",
      "expire": "📅 有効期限：{{ .Time }}\r\n",
      "expireIn": "📅 残り時間：{{ .Time }}\r\n",
      "active": "💡 有効：{{ .Enable }}\r\n",
      "enabled": "🚨 有効化済み：{{ .Enable }}\r\n",
      "online": "🌐 接続ステータス：{{ .Status }}\r\n",
      "lastOnline": "🔙 最終オンライン: {{ .Time }}\r\n",
      "email": "📧 メール: {{ .Email }}\r\n",
      "upload": "🔼 アップロード: ↑{{ .Upload }}\r\n",
      "download": "🔽 ダウンロード: ↓{{ .Download }}\r\n",
      "total": "📊 合計: ↑↓{{ .UpDown }} / {{ .Total }}\r\n",
      "TGUser": "👤 Telegramユーザー：{{ .TelegramID }}\r\n",
      "exhaustedMsg": "🚨 消耗済みの {{ .Type }}：\r\n",
      "exhaustedCount": "🚨 消耗済みの {{ .Type }} 数量：\r\n",
      "onlinesCount": "🌐 オンラインクライアント：{{ .Count }}\r\n",
      "disabled": "🛑 無効化：{{ .Disabled }}\r\n",
      "depleteSoon": "🔜 間もなく消耗：{{ .Deplete }}\r\n\r\n",
      "backupTime": "🗄 バックアップ時間：{{ .Time }}\r\n",
      "refreshedOn": "\r\n📋🔄 更新時間：{{ .Time }}\r\n\r\n",
      "yes": "✅ はい",
      "no": "❌ いいえ",
      "received_id": "🔑📥 IDが更新されました。",
      "received_password": "🔑📥 パスワードが更新されました。",
      "received_email": "📧📥 メールが更新されました。",
      "received_comment": "💬📥 コメントが更新されました。",
      "id_prompt": "🔑 デフォルトID: {{ .ClientId }}\n\nIDを入力してください。",
      "pass_prompt": "🔑 デフォルトパスワード: {{ .ClientPassword }}\n\nパスワードを入力してください。",
      "email_prompt": "📧 デフォルトメール: {{ .ClientEmail }}\n\nメールを入力してください。",
      "comment_prompt": "💬 デフォルトコメント: {{ .ClientComment }}\n\nコメントを入力してください。",
      "inbound_client_data_id": "🔄 インバウンド: {{ .InboundRemark }}\n\n🔑 ID: {{ .ClientId }}\n📧 メール: {{ .ClientEmail }}\n📊 トラフィック: {{ .ClientTraffic }}\n📅 有効期限: {{ .ClientExp }}\n🌐 IP制限: {{ .IpLimit }}\n💬 コメント: {{ .ClientComment }}\n\n今すぐこのクライアントをインバウンドに追加できます！",
      "inbound_client_data_pass": "🔄 インバウンド: {{ .InboundRemark }}\n\n🔑 パスワード: {{ .ClientPass }}\n📧 メール: {{ .ClientEmail }}\n📊 トラフィック: {{ .ClientTraffic }}\n📅 有効期限: {{ .ClientExp }}\n🌐 IP制限: {{ .IpLimit }}\n💬 コメント: {{ .ClientComment }}\n\n今すぐこのクライアントをインバウンドに追加できます！",
      "cancel": "❌ プロセスがキャンセルされました！\n\nいつでも /start で再開できます。 🔄",
      "error_add_client": "⚠️ エラー:\n\n {{ .error }}",
      "using_default_value": "わかりました、デフォルト値を使用します。 😊",
      "incorrect_input": "入力が無効です。\nフレーズはスペースなしで続けて入力してください。\n正しい例: aaaaaa\n間違った例: aaa aaa 🚫",
      "AreYouSure": "本当にいいですか？🤔",
      "SuccessResetTraffic": "📧 メール: {{ .ClientEmail }}\n🏁 結果: ✅ 成功",
      "FailedResetTraffic": "📧 メール: {{ .ClientEmail }}\n🏁 結果: ❌ 失敗 \n\n🛠️ エラー: [ {{ .ErrorMessage }} ]",
      "FinishProcess": "🔚 すべてのクライアントのトラフィックリセットが完了しました。"
    },
    "buttons": {
      "closeKeyboard": "❌ キーボードを閉じる",
      "cancel": "❌ キャンセル",
      "cancelReset": "❌ リセットをキャンセル",
      "cancelIpLimit": "❌ IP制限をキャンセル",
      "confirmResetTraffic": "✅ トラフィックをリセットしますか？",
      "confirmClearIps": "✅ IPをクリアしますか？",
      "confirmRemoveTGUser": "✅ Telegramユーザーを削除しますか？",
      "confirmToggle": "✅ ユーザーを有効/無効にしますか？",
      "dbBackup": "データベースバックアップを取得",
      "serverUsage": "サーバーの使用状況",
      "getInbounds": "インバウンド情報を取得",
      "depleteSoon": "間もなく消耗",
      "clientUsage": "使用状況を取得",
      "onlines": "オンラインクライアント",
      "commands": "コマンド",
      "refresh": "🔄 更新",
      "clearIPs": "❌ IPをクリア",
      "removeTGUser": "❌ Telegramユーザーを削除",
      "selectTGUser": "👤 Telegramユーザーを選択",
      "selectOneTGUser": "👤 1人のTelegramユーザーを選択：",
      "resetTraffic": "📈 トラフィックをリセット",
      "resetExpire": "📅 有効期限を変更",
      "ipLog": "🔢 IPログ",
      "ipLimit": "🔢 IP制限",
      "setTGUser": "👤 Telegramユーザーを設定",
      "toggle": "🔘 有効/無効",
      "custom": "🔢 カスタム",
      "confirmNumber": "✅ 確認: {{ .Num }}",
      "confirmNumberAdd": "✅ 追加を確認：{{ .Num }}",
      "limitTraffic": "🚧 トラフィック制限",
      "getBanLogs": "禁止ログ",
      "allClients": "すべてのクライアント",
      "addClient": "クライアントを追加",
      "submitDisable": "無効として送信 ☑️",
      "submitEnable": "有効として送信 ✅",
      "use_default": "🏷️ デフォルトを使用",
      "change_id": "⚙️🔑 ID",
      "change_password": "⚙️🔑 パスワード",
      "change_email": "⚙️📧 メール",
      "change_comment": "⚙️💬 コメント",
      "change_flow": "⚙️🚦 Flow",
      "ResetAllTraffics": "すべてのトラフィックをリセット",
      "SortedTrafficUsageReport": "ソートされたトラフィック使用レポート"
    },
    "answers": {
      "successfulOperation": "✅ 成功！",
      "errorOperation": "❗ 操作エラー。",
      "getInboundsFailed": "❌ インバウンド情報の取得に失敗しました。",
      "getClientsFailed": "❌ クライアントの取得に失敗しました。",
      "canceled": "❌ {{ .Email }}：操作がキャンセルされました。",
      "clientRefreshSuccess": "✅ {{ .Email }}：クライアントが正常に更新されました。",
      "IpRefreshSuccess": "✅ {{ .Email }}：IPが正常に更新されました。",
      "TGIdRefreshSuccess": "✅ {{ .Email }}：クライアントのTelegramユーザーが正常に更新されました。",
      "resetTrafficSuccess": "✅ {{ .Email }}：トラフィックが正常にリセットされました。",
      "setTrafficLimitSuccess": "✅ {{ .Email }}：トラフィック制限が正常に保存されました。",
      "expireResetSuccess": "✅ {{ .Email }}：有効期限の日数が正常にリセットされました。",
      "resetIpSuccess": "✅ {{ .Email }}：IP制限数が正常に保存されました：{{ .Count }}。",
      "clearIpSuccess": "✅ {{ .Email }}：IPが正常にクリアされました。",
      "getIpLog": "✅ {{ .Email }}：IPログの取得。",
      "getUserInfo": "✅ {{ .Email }}：Telegramユーザー情報の取得。",
      "removedTGUserSuccess": "✅ {{ .Email }}：Telegramユーザーが正常に削除されました。",
      "enableSuccess": "✅ {{ .Email }}：正常に有効化されました。",
      "disableSuccess": "✅ {{ .Email }}：正常に無効化されました。",
      "askToAddUserId": "設定が見つかりませんでした！\r\n管理者に問い合わせて、設定にTelegramユーザーのChatIDを使用してください。\r\n\r\nあなたのユーザーChatID：<code>{{ .TgUserID }}</code>",
      "chooseClient": "インバウンド {{ .Inbound }} のクライアントを選択",
      "chooseInbound": "インバウンドを選択"
    }
  }
}
